import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { fetchBrandData } from "./brandAPI";
import { RootState } from "../../state/store";

export interface BrandState {
  brands: { [key: string]: number };
  selectedBrands: string[];
  loading: boolean;
  error: string | null;
}

const initialState: BrandState = {
  brands: {},
  selectedBrands: [],
  loading: false,
  error: null,
};

export const fetchBrands = createAsyncThunk<{ [key: string]: number }, any>(
  "brand/fetchBrands",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await fetchBrandData(payload);
      return response;
    } catch (error: any) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

const brandSlice = createSlice({
  name: "brand",
  initialState,
  reducers: {
    setSelectedBrandValues: (state, action: PayloadAction<string[]>) => {
      state.selectedBrands = action.payload;
    },
    resetBrandValues: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchBrands.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(
      fetchBrands.fulfilled,
      (state, action: PayloadAction<{ [key: string]: number }>) => {
        state.loading = false;
        state.brands = action.payload;
        state.selectedBrands = Object.keys(action.payload);
      }
    );
    builder.addCase(
      fetchBrands.rejected,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch brand data";
      }
    );
  },
});

export const { setSelectedBrandValues, resetBrandValues } = brandSlice.actions;

export const selectBrands = (state: RootState) => state.brand.brands;
export const selectSelectedBrands = (state: RootState) =>
  state.brand.selectedBrands;
export const selectLoading = (state: RootState) => state.brand.loading;
export const selectError = (state: RootState) => state.brand.error;

export default brandSlice.reducer;
